<template>
  <div v-if="events.length > 0">
    <v-list two-line>
      <template v-for="(event, index) in events">
        <v-list-item :key="event.id" ripple>
          <v-list-item-content>
            <v-list-item-title>{{ event.event }}</v-list-item-title>
            <v-list-item-subtitle class="text--primary">
              {{
              event.type
              }}
            </v-list-item-subtitle>
            <v-list-item-subtitle>
              {{ event.user.username }} ({{
              event.timestamp
              }})
            </v-list-item-subtitle>
          </v-list-item-content>
        </v-list-item>
        <v-divider v-if="index + 1 < events.length" :key="index"></v-divider>
      </template>
    </v-list>
    <v-pagination
      v-model="pagination.page"
      :length="pagination.pageCount"
      :totalVisible="10"
      v-if="pagination.pageCount > 1"
    ></v-pagination>
  </div>
</template>

<script>
export default {
  data() {
    return {
      events: [],
      pagination: { page: 1, rowsPerPage: 5 },
      loading: false
    };
  },
  props: {
    orderId: { type: Number }
  },
  mounted: function() {
    this.getEvent();
  },
  watch: {
    "pagination.page": function() {
      this.getEvent();
    }
  },
  methods: {
    getEvent() {
      this.loading = true;
      this.events = [];
      this.$store
        .dispatch("orders/events", {
          orderId: this.orderId,
          pagination: this.pagination
        })
        .then(({events}) => {
          this.events = events.data;
          this.pagination.pageCount = events.last_page;
        })
        .finally(() => {
          this.loading = false;
        });
    }
  }
};
</script>

<style></style>
